import { render, staticRenderFns } from "./supportcontract.vue?vue&type=template&id=52a3934d&scoped=true&"
import script from "./supportcontract.vue?vue&type=script&lang=js&"
export * from "./supportcontract.vue?vue&type=script&lang=js&"
import style0 from "./supportcontract.vue?vue&type=style&index=0&id=52a3934d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a3934d",
  null
  
)

export default component.exports